<template>
  <div class="wf-product-collection">
    <div class="wf-product-collection-results d-flex flex-wrap">
      <product-search-result
        v-for="(item, index) in sortedItems"
        :item="item"
        :key="item.styleNumber"
        :product-index="index"
      />
      <pc-load-more
        class="mb-5"
        v-if="showLoadMore"
        :load-more="onLoadMore"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ProductSearchResult from "./product-search/pc-product-search-result.vue";
import PcLoadMore from "./common/pc-loading-more.vue";

export default {
  props: {
    collectionCode: {
      type: String,
      required: true
    }
  },
  components: {
    ProductSearchResult,
    PcLoadMore
  },
  computed: {
    ...mapGetters({
      items: "productDisplay/items",
      sortOrder: "filters/sortOrder",
      isAscendingOrder: "filters/isAscendingOrder",
      isFetching: "productDisplay/isFetching",
      showLoadMore: "productDisplay/showLoadMore",
      pageNumber: "productDisplay/pageNumber",
      pageSize: "productDisplay/pageSize"
    }),
    changedSorting() {
      return `${this.sortOrder}|${this.isAscendingOrder}`;
    },
    sortedItems() {
      const sortedByColors = this.items.map(item => {
        if (item.colors && Array.isArray(item.colors)) {
          item.colors.sort((a, b) => a.colorNumber.localeCompare(b.colorNumber));
        }
        return item; 
      });

      return sortedByColors.slice().sort((a, b) => {
        const getNumericPart = (item) => {
          const match = item.styleNumber.match(/\d+/);
          return match ? parseInt(match[0], 10) : 0;
        };
        const numericA = getNumericPart(a);
        const numericB = getNumericPart(b);
        return numericA - numericB;
      });
    }
  },
  methods: {
    ...mapActions({
      fetchResults: "productDisplay/fetchResults",
      setPageNumber: "productDisplay/setPageNumber"
    }),
    onLoadMore() {
      if (this.isFetching) {
        return;
      }
      this.setPageNumber(this.pageNumber + 1);
      this.onSearch();
    },
    onSearch() {
      this.fetchResults({
        filter: {
          OrderColumn: this.sortOrder,
          IsAscendingOrder: this.isAscendingOrder === "asc",
          Filter: `CollectionCode eq '${this.collectionCode}'`,
          CollectionCode: this.collectionCode,
          IsEnabledOnSite: true,
          IsDisabledOnSearch: false,
          PageSize: this.pageSize
        },
      }, true); 
    },
  },
  mounted() {
    this.onSearch();
  },
  watch: {
    changedSorting: {
      handler: function () {
        this.setPageNumber(1);
        this.onSearch();
      },
      deep: true
    }
  }
};
</script>

<style></style>
